<div class="custom-toolbar">
  <div class="custom-toolbar-subdivision-left custom-toolbar-element">
    <yo-help lang="fr" [file]="pathFile" [width]="800"></yo-help>
    <yo-button
      iconClass="fa fa-plus"
      [theme]="ButtonThemeEnum.ADD"
      label="CRÉER"
      (onClick)="openDialogEdition()"
      tooltip="Créer une communication produit">
    </yo-button>
  </div>
  <div class="custom-toolbar-subdivision-right">
    <div class="custom-button-container">
      <yo-button
        iconClass="fas fa-trash"
        [theme]="ButtonThemeEnum.DELETE"
        (onClick)="deleteValues()"
        [disabled]="!canDelete()"
        tooltip="Supprimer les éléments sélectionnés">
      </yo-button>
    </div>
  </div>
</div>

<dx-data-grid
  [dataSource]="communicationProduitList"
  keyExpr="id"
  class="data-grid"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [(selectedRowKeys)]="selectedRows"
  columnResizingMode="widget"
  #grid>
  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple"
  ></dxo-selection>
  <dxi-column dataField="id" caption="Actions"
              [width]="79"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="site" caption="Site"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              cellTemplate="siteTemplate"
              [calculateCellValue]="calculateSiteValue">
  </dxi-column>
  <dxi-column dataField="typeProduit.libelle" caption="Type de produit"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="libelle" caption="Libellé"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="code" caption="Code"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="actif" caption="Actif"
              width="9.5%"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER"
      (onClick)="openDialogEdition(cell.row.data)"
      [iconClass]="communicationProduitSvc.canModify(cell.row.data)? 'fa fa-edit' : 'fas fa-eye'"
      [tooltip]="communicationProduitSvc.canModify(cell.row.data)? 'Modifier la communication produit' : 'Voir la communication produit'">
    </yo-button>
  </div>

  <div *dxTemplate="let cell of 'siteTemplate'">
    <yo-site [siteLibelle]="cell.row.data?.site?.libelle" [siteId]="cell.row.data?.site?.id"></yo-site>
  </div>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} communications produit">
  </dxo-pager>

</dx-data-grid>

<yo-communication-produit-dialog></yo-communication-produit-dialog>
